var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(" Você não está autorizado a ver essa tela ")]),_c('v-icon',{staticClass:"mt-5",attrs:{"color":"primary"}},[_vm._v("mdi-security")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }